/* eslint-disable no-param-reassign */
import axios from 'axios'
// import Vue from 'vue'
const baseURL = process.env.VUE_APP_BASE_URL

export default {
   namespaced: true,
   state: {
      data: [],
      countAll: 0,
      current: 0,
      success: 0,
      failed: 0,
      runningState: false,
      cancelToken: '',
   },
   getters: {},
   actions: {
      async getData({ commit, rootState }) {
         rootState.isLoading = true
         return axios.get(`${baseURL}oss/scrap/download/nib`).then(
            response => {
               commit('SET_DATA', response.data.items)
               commit('SET_COUNT', response.data.items)
               rootState.isLoading = false
               return Promise.resolve(response.data.items)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
      async runScrap({ commit, rootState }, param) {
         rootState.isLoading = true

         try {
            const res = await axios.post(`${baseURL}oss/scrap/download/nib`, param)
            commit('SET_SUCCESS')
            commit('NEXT')
            return res
         } catch (error) {
            commit('SET_FAILED')
            commit('NEXT')
            throw error
         } finally {
            rootState.isLoading = false
         }
      },
      runLogin({ rootState }) {
         rootState.isLoading = true
         return axios.post(`${baseURL}oss/scrap/login`).then(
            response => {
               rootState.isLoading = false
               return Promise.resolve(response.data)
            },
            () => {
               rootState.isLoading = false
               return Promise.reject()
            },
         )
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.data = data
      },
      SET_COUNT(state, data) {
         state.countAll = data.length
      },
      SET_CURRENT(state, data) {
         state.current = data
      },
      SET_SUCCESS(state) {
         state.success += 1
      },
      SET_FAILED(state) {
         state.failed += 1
      },
      SET_STATE(state, data) {
         state.runningState = data
      },
      SET_CANCEL_TOKEN(state, data) {
         state.cancelToken = data
      },
      NEXT(state) {
         state.current += 1
      },
   },
}
